
$('.filters-second .navbar-nav .parent-category').on('click', function() {
  $('.parent-category').not(this).parent().find('.dropdown-menu').slideUp('fast');
  $('.parent-category').not(this).parent().find('.fa-angle-up').removeClass('fa-angle-up').addClass('fa-angle-down')

  $(this).parent().find('.dropdown-menu').slideToggle('fast');
  $(this).parent().find('.icon').toggleClass('fa-angle-down').toggleClass('fa-angle-up');

  setTimeout(function(){
  $('html, body').animate({
    scrollTop: $(".parent-category .fa-angle-up").offset().top - 20
  }, 500);
}, 200);
});

// ============== SIDR MENU ==============
if (checkIfExists('#categories-nav')) {
  $('.navbar-toggler').sidr({
    name: 'sidr-nav',
    source: '#categories-nav, .top-navigation, #contacts-box',
    body: '.content-sidr',
    renaming :false,
    onOpen: function() {
      // $(".content").addClass('overlay');
      $('.overlay').fadeIn('fast').css('z-index', '1030');
    },
    onClose: function() {
      // $(".content").removeClass('overlay');
      $('.overlay').fadeOut('fast');

    }
  });

  $(document).on('click', '#sidr-nav .parent-category', function() {
    // $('#sidr-nav .parent-category').not(this).removeClass('dropdown-show').parent().find('.dropdown-menu').slideUp('fast');
    // $('#sidr-nav .parent-category').not(this).removeClass('dropdown-show').parent().find('.fa-angle-up').removeClass('fa-angle-up').addClass('fa-angle-down')

    $(this).addClass('dropdown-show').parent().find('.dropdown-menu').slideToggle('fast');
    $(this).addClass('dropdown-show').parent().find('.parent-category .fas').toggleClass('fa-angle-down').toggleClass('fa-angle-up')
  });

}else{
  $('.navbar-toggler').sidr({
    name: 'sidr-nav',
    source: '.mobile-menu, .top-navigation, #contacts-box',
    body: '.content-sidr',
    renaming :false,
    onOpen: function() {
      // $(".content").addClass('overlay');
      $('.overlay').fadeIn('fast').css('z-index', '1030');
    },
    onClose: function() {
      // $(".content").removeClass('overlay');
      $('.overlay').fadeOut('fast');

    }
  });

}

$(document).on('click', '#sidr-nav .toggle-types', function(e){
  e.preventDefault();
  // $('#sidr-nav .toggle-types').not(this).next().slideUp('fast')
  $(this).next().slideToggle('fast')
});

$('.close-sidr-btn').on('click', function(){
  $.sidr("close", "sidr-nav");
})


// $('.quick-cart, .mobile-cart-btn').on('click', function(e){
//   e.preventDefault();
//   $('.quick-cart-items').addClass('cart-active');
//   $('.overlay').fadeIn('fast').css('z-index', '1030');
//   $('html, body').addClass('overflow-hidden');
//   $('.mm-slideout').css('z-index', '1031');
// });

$('.overlay, .close-cart, .close-filter').click(function (e) {
  e.preventDefault();
  removeOpenedWindows();
})


$('#sidr-nav .dropdown-toggle').on('click', function () {
  $('#sidr-nav .dropdown-toggle').not(this).removeClass('dropdown-show');
  $(this).addClass('dropdown-show').parent().children(".dropdown-menu").slideToggle('fast');

  // $('#sidr-nav .dropdown-toggle').not('.dropdown-show').parent().children(".dropdown-menu").slideUp('fast');
});

$('header .mobile-search-toggle, header .close-search').click(function (e) {
  e.preventDefault();
  if (!$('header .search-form').is(':visible')) {
    $('header .search-form').stop().slideDown('fast');
    $('header .search-form').find('input').focus();
    $('.overlay').fadeIn('fast');
    $('#bottom-header').addClass('search-opened');
    return
  }
  $('header .search-form').stop().slideUp('fast');
  $('.overlay').fadeOut('fast');
  $('#bottom-header').removeClass('search-opened');
})


if ($('body').innerHeight() > 1800) {
  $(window).scroll(function () {
    if ($(window).scrollTop() > 250) {
      $('.sticky-nav').addClass('fixed-top');
    }
    if ($(window).scrollTop() < 250) {
      $('.sticky-nav').removeClass('fixed-top');
    }
  });
}
